var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "place-zones" },
    [
      _c(
        "v-expansion-panels",
        _vm._l(_vm.seatRowsList, function (row, rowIndex) {
          return _c(
            "v-expansion-panel",
            {
              key: rowIndex,
              staticClass: "place-zones__collapse-item mb-5",
              attrs: { name: rowIndex },
            },
            [
              _c(
                "v-expansion-panel-header",
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "d-flex align-center",
                          attrs: { cols: "4" },
                        },
                        [_vm._v(" " + _vm._s(row.title) + " ")]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "d-flex align-center",
                          attrs: { cols: "4" },
                        },
                        [_vm._v("Место")]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "d-flex justify-end",
                          attrs: { cols: "4" },
                        },
                        [
                          _c(
                            "v-menu",
                            {
                              attrs: { "offset-y": "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on, attrs }) {
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                attrs: {
                                                  icon: "",
                                                  disabled: _vm.isLoading,
                                                  loading: _vm.isLoading,
                                                },
                                              },
                                              "v-btn",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c("v-icon", [
                                              _vm._v("mdi-dots-vertical"),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c(
                                "v-list",
                                [
                                  _c(
                                    "v-list-item",
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { icon: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.$emit(
                                                "duplicate-seat-row",
                                                rowIndex
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("v-icon", [
                                            _vm._v("mdi-content-copy"),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-list-item",
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            disabled:
                                              _vm.isLoading || _vm.isOnlyEdit,
                                            loading: _vm.isLoading,
                                            icon: "",
                                            color: "red",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.$emit(
                                                "remove-seat-row",
                                                { id: row.id, index: rowIndex }
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("v-icon", [
                                            _vm._v("mdi-trash-can-outline"),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-expansion-panel-content",
                _vm._l(_vm.sortSeats(row.seats), function (seat, seatIndex) {
                  return _c(
                    "v-row",
                    {
                      key: seatIndex,
                      staticClass: "place-zones__collapse-item-details",
                    },
                    [
                      _c("v-col", { attrs: { cols: "2" } }, [
                        _c("div", [_vm._v("Место " + _vm._s(seat.number))]),
                      ]),
                      _c(
                        "v-col",
                        {
                          staticClass: "d-flex justify-end",
                          attrs: { cols: "2", offset: "8" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                disabled: _vm.isLoading || _vm.isOnlyEdit,
                                loading: _vm.isLoading,
                                icon: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("remove-seat", {
                                    id: seat.id,
                                    index: seatIndex,
                                    seatRowIndex: rowIndex,
                                  })
                                },
                              },
                            },
                            [
                              _c("v-icon", { attrs: { color: "red" } }, [
                                _vm._v("mdi-trash-can-outline"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          )
        }),
        1
      ),
      _vm.isCreateRowEnabled
        ? _c("div", { staticClass: "place-zones__form" }, [
            _c(
              "div",
              { staticClass: "place-zones__form-item is-left" },
              [
                _c("span", [_vm._v("Название ряда")]),
                _c("v-text-field", {
                  attrs: { outlined: "", disabled: _vm.isLoading },
                  model: {
                    value: _vm.rowTitle,
                    callback: function ($$v) {
                      _vm.rowTitle = typeof $$v === "string" ? $$v.trim() : $$v
                    },
                    expression: "rowTitle",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "place-zones__form-item is-right" },
              [
                _c("span", [_vm._v("Места")]),
                _c("v-text-field", {
                  attrs: {
                    outlined: "",
                    disabled: _vm.isLoading || _vm.isOnlyEdit,
                  },
                  model: {
                    value: _vm.number,
                    callback: function ($$v) {
                      _vm.number = $$v
                    },
                    expression: "number",
                  },
                }),
                _c(
                  "v-btn",
                  {
                    attrs: { loading: _vm.isLoading, disabled: _vm.isLoading },
                    on: { click: _vm.createSeating },
                  },
                  [_vm._v("Добавить")]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "mt-10" },
        [
          _c(
            "v-btn",
            {
              attrs: {
                disabled: _vm.isLoading || _vm.isOnlyEdit,
                loading: _vm.isLoading,
              },
              on: { click: _vm.toggleCreateRowEnabled },
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.isCreateRowEnabled ? "Отменить" : "Добавить ряд") +
                  " "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }